<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/community-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">系统赋能，贴合不同的分销场景</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/community01.png" alt="">
          <span class="title">人人都是销售员</span>
          <div class="line" />
          <span class="text">招募代理人，不断裂变，通过任务奖励、商品佣金奖励刺激代理人将商品、活动分享到微信朋友圈，微信好友，实现社群传播，实现商品销售</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/community02.png" alt="">
          <span class="title">每个门店都分销</span>
          <div class="line" />
          <span class="text">为门店提供销货通道，通过接入平台商品库，将商品同步给体系内所以的门店，让门店帮你做分销，销售通路广，销量不用愁</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/community03.png" alt="">
          <span class="title">整合上游优质供应链</span>
          <div class="line" />
          <span class="text">提供海量优质商品，让门店不愁没有好货做分销，甚至提供一件代发服务，不囤货也能开店，通过商品吸引更多粉丝进店</span>
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">社群电商场景</div>
      </div>
      <img src="@/assets/Mobile/images/solution/community04.png" alt="">
    </div>
    <div class="information">
      <div class="sk-mobile-title">
        <div class="title">“三大利器”助力开展分享裂变</div>
      </div>
      <div class="content">
        <span class="title">多门店商品分销渠道</span>
        <span class="text">平台会叠加丰富得分销商品，帮助会员店去引流<br>会员店可以将自己的商品申请到平台上，由平台推广到其他会员店帮助分销</span>
        <span class="title">任务推广：丰富的推广内容更大的促进用户活跃</span>
        <span class="text">总部通过任务机制，参与并完成相应任务分销员会获得额外的奖励，帮助门店活跃分销员<br>门店可以在总部奖励的基础上叠加自己的奖励，如优惠券、服务券等奖励分销员</span>
        <span class="title">互动营销</span>
        <span class="text">秒杀、优惠券、拼团等多样的互动营销玩法助力用户裂变</span>
        <img src="@/assets/Mobile/images/solution/community05.png" alt="">
      </div>
    </div>
    <div class="information block03">
      <div class="sk-mobile-title">
        <div class="title">核心功能</div>
      </div>
      <div class="content">
        <span class="title">丰富的任务玩法</span>
        <span class="text">拉新任务：分享拉新、扫码拉新<br>互动任务：游戏、阅读、交流<br>传播任务：活动分享广告传播</span>
        <span class="title">酬劳多样化</span>
        <span class="text">分销员分销、推广除佣金收入外，还可以叠加优惠券、积分、服务券等多种酬劳方式，更贴合实际店铺经营场景</span>
        <span class="title">多种营销手段，快速提升销量</span>
        <span class="text">拉新任务，活动任务等，结合秒杀，优惠券、拼团及专属的推广分销通道等，充分利于微信、朋友圈等社群进行多渠道推广，成本低，效果显著</span>
        <span class="title">强大的分销系统</span>
        <span class="text">一键分销，自动分账，操作简便，商品多渠道独立管理，库存、订单即时同步，多种模式，满足多样化需求</span>
        <img src="@/assets/Mobile/images/solution/community06.png" alt="">
      </div>
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">适用场景</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/community07.png" alt="">
          <span>电商平台</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/community08.png" alt="">
          <span>品牌商</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/community09.png" alt="">
          <span>生产厂家</span>
        </div>
      </div>
    </div>
    <Case title="社群分销" />

    <ContactForm info-sources="社群分销" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.Community,
  components: {
    ContactForm,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  .content {
    padding: 20px 0 10px 0px;
    .item {
      width: 343px;
      height: 296px;
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(221, 221, 221, 0.5);
      border-radius: 6px;
      margin: 0 auto 10px auto;
      padding: 0 23px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 115px;
        margin-top: 21px;
      }
      .title {
        margin-top: 12px;
        font-size: 18px;
        font-weight: 500;
        color: #595961;
        line-height: 25px;
      }
      .line {
        margin-top: 12px;
        width: 40px;
        height: 6px;
        background: #2F81E8;
      }
      .text {
        margin-top: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #595961;
        line-height: 22px;
        text-align: left;
      }
    }
  }
}
.block02 {
  background-color: #FAFAFA;
  img {
    width: 340px;
    margin-bottom: 10px;
  }
}
.block03 {
  background-color: #FAFAFA;
  img {
    width: 340px;
    margin: 22px 0;
  }
}
.information {
  .content {
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .title {
      margin-top: 12px;
      font-size: 14px;
      font-weight: 600;
      color: #595961;
      line-height: 20px
    }
    .text {
      font-size: 11px;
      font-weight: 400;
      color: #595961;
      line-height: 22px;
      text-align: left;
    }
    img {
      width: 242px;
      margin: 14px auto 0 auto;
    }
  }
}
.block03 {
  background-color: #FAFAFA;
}
.block04 {
  .content {
    padding-top: 20px;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 296px;
      }
      span {
        font-size: 14px;
        font-weight: 500;
        color: #595961;
        line-height: 20px;
        margin: 15px 0 30px 0;
      }
    }
  }
}
</style>
